/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiplomeCertificationFichierGridDto
 */
export interface DiplomeCertificationFichierGridDto {
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierGridDto
     */
    iddiplomeCertificationFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierGridDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationFichierGridDto
     */
    typeAcquisFichier?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierGridDto
     */
    idfichier?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationFichierGridDto
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationFichierGridDto
     */
    uploadUser?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationFichierGridDto
     */
    creationUserName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DiplomeCertificationFichierGridDto
     */
    uploadDate?: Date | null;
}

/**
 * Check if a given object implements the DiplomeCertificationFichierGridDto interface.
 */
export function instanceOfDiplomeCertificationFichierGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationFichierGridDtoFromJSON(json: any): DiplomeCertificationFichierGridDto {
    return DiplomeCertificationFichierGridDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationFichierGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationFichierGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddiplomeCertificationFichier': !exists(json, 'iddiplomeCertificationFichier') ? undefined : json['iddiplomeCertificationFichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'typeAcquisFichier': !exists(json, 'typeAcquisFichier') ? undefined : json['typeAcquisFichier'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
        'uploadUser': !exists(json, 'uploadUser') ? undefined : json['uploadUser'],
        'creationUserName': !exists(json, 'creationUserName') ? undefined : json['creationUserName'],
        'uploadDate': !exists(json, 'uploadDate') ? undefined : (json['uploadDate'] === null ? null : new Date(json['uploadDate'])),
    };
}

export function DiplomeCertificationFichierGridDtoToJSON(value?: DiplomeCertificationFichierGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddiplomeCertificationFichier': value.iddiplomeCertificationFichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'typeAcquisFichier': value.typeAcquisFichier,
        'idfichier': value.idfichier,
        'fileName': value.fileName,
        'uploadUser': value.uploadUser,
        'creationUserName': value.creationUserName,
        'uploadDate': value.uploadDate === undefined ? undefined : (value.uploadDate === null ? null : value.uploadDate.toISOString()),
    };
}

